import type React from 'react';
import { render } from 'react-dom';

// * https://reactjs.org/blog/2022/03/08/react-18-upgrade-guide.html#updates-to-client-rendering-apis
// TODO: Move to createRoot once ready
export const renderRootForContainerId = (
  id: string,
  component: React.ReactElement,
) => {
  const container = document.getElementById(id);

  if (!container) {
    console.error(`container not found for ${id}`);
    return;
  }

  render(component, container);
};
